import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../../../constants/general-constants";
import AmChartDoughnutIndicator from "../../../components/AmChartDoughnutIndicator";

export default function UtilisationKpiIndicator({id, title, number, utilisation}){
	
	const thisContainer = {
		display:'flex',
		backgroundColor:"white",
		height:"120px",
		marginLeft:"20px",
		marginTop:"20px",
		borderLeft:"1px solid lightgrey"
	};
	
	const leftContent = {
		display:"flex",
		flexDirection:"column",
		width:"100px"
	};
	
	const titleContainer = {
		display:'flex',
		height:"33px",
		alignItems:'center',
		fontSize:"14px",
		justifyContent:"space-around",
		fontWeight:"bold"
	};
	
	const numberContainer = {
		display:'flex',
		height:"60px",
		alignItems:'center',
		fontSize:"36px",
		justifyContent:"space-around",
		color:"black"
	};
	
	const pieContainer = {
		display:"flex",
		width:"140px",
		height:"120px",
		paddingTop:"10px"
	};
	
	return (
		<div style={thisContainer}>
		 <div style={leftContent}>
		 	<div style={titleContainer}>
		 		{title}
		 	</div>
		 	<div style={numberContainer}>
		 		{number}
		 	</div>
		 </div>
		 <div style={pieContainer}>
		 <AmChartDoughnutIndicator
					id={id}
					percentage={utilisation}
					width="140"
					height="140"
					color="blue"
				/>
		 </div>
		</div>
	);
}